<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        CONFIGURAR RECOMPENSAS
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
                <v-card>
                    <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch v-model="form.enabled" label="Activar recompensas por videos" color="primary" :disabled="loading"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-alert dense text type="warning" class="mb-0">
                                        {{ settings.admob_policy_notice || 'AdMob permite puntos o beneficios internos no transferibles. No se debe ofrecer efectivo, cripto, gift cards ni saldo wallet como recompensa directa.' }}
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.admob_android_ad_unit_id"
                                        label="AdMob Android Ad Unit ID"
                                        prepend-icon="mdi-android"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.admob_ios_ad_unit_id"
                                        label="AdMob iOS Ad Unit ID"
                                        prepend-icon="mdi-apple"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :value="settings.ssv_callback_url"
                                        label="URL callback SSV AdMob"
                                        prepend-icon="mdi-link-lock"
                                        append-icon="mdi-content-copy"
                                        readonly
                                        @click:append="copy(settings.ssv_callback_url)"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-switch
                                        v-model="form.ssv_verification_enabled"
                                        label="Validar firma de Google"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-switch
                                        v-model="form.require_verified_user"
                                        label="Solo clientes verificados"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="form.cash_redemption_enabled"
                                        label="Canje directo a dinero, cripto o saldo wallet"
                                        color="warning"
                                        disabled
                                        hint="Desactivado para recompensas AdMob"
                                        persistent-hint/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select
                                        v-model="form.reward_value_mode"
                                        :items="rewardModes"
                                        item-text="text"
                                        item-value="value"
                                        label="Como calcular puntos"
                                        prepend-icon="mdi-calculator"
                                        :rules="[rules.req('reward_value_mode')]"
                                        :error-messages="errors.reward_value_mode"
                                        :disabled="loading"
                                        @change="clearErrors('reward_value_mode')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.customer_share_percent"
                                        label="Porcentaje para el cliente"
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="0.01"
                                        suffix="%"
                                        prepend-icon="mdi-percent"
                                        :rules="[rules.req('customer_share_percent')]"
                                        :error-messages="errors.customer_share_percent"
                                        :disabled="loading"
                                        @input="clearErrors('customer_share_percent')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.estimated_revenue_per_video_usdt"
                                        label="Ingreso estimado Google por video"
                                        type="number"
                                        min="0"
                                        step="0.000001"
                                        suffix="USDT"
                                        prepend-icon="mdi-google-ads"
                                        :rules="[rules.req('estimated_revenue_per_video_usdt')]"
                                        :error-messages="errors.estimated_revenue_per_video_usdt"
                                        :disabled="loading"
                                        @input="clearErrors('estimated_revenue_per_video_usdt')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-switch
                                        v-model="form.use_admob_reward_amount"
                                        label="Usar recompensa configurada en AdMob"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.admob_reward_item"
                                        label="Nombre de recompensa"
                                        prepend-icon="mdi-ticket-percent"
                                        :rules="[rules.req('admob_reward_item')]"
                                        :error-messages="errors.admob_reward_item"
                                        :disabled="loading"
                                        @input="clearErrors('admob_reward_item')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.points_per_video"
                                        label="Puntos por video"
                                        type="number"
                                        min="0"
                                        step="0.0001"
                                        prepend-icon="mdi-counter"
                                        :rules="[rules.req('points_per_video')]"
                                        :error-messages="errors.points_per_video"
                                        :disabled="loading"
                                        @input="clearErrors('points_per_video')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.point_value_usdt"
                                        label="Referencia interna por punto"
                                        type="number"
                                        min="0"
                                        step="0.000001"
                                        suffix="USDT ref."
                                        prepend-icon="mdi-currency-usd"
                                        :rules="[rules.req('point_value_usdt')]"
                                        :error-messages="errors.point_value_usdt"
                                        :disabled="loading"
                                        @input="clearErrors('point_value_usdt')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.min_redeem_points"
                                        label="Minimo de puntos para beneficio"
                                        type="number"
                                        min="0"
                                        step="0.0001"
                                        prepend-icon="mdi-wallet-giftcard"
                                        :rules="[rules.req('min_redeem_points')]"
                                        :error-messages="errors.min_redeem_points"
                                        :disabled="loading"
                                        @input="clearErrors('min_redeem_points')"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-row dense>
                                        <v-col cols="12" md="4">
                                            <v-sheet outlined rounded class="pa-3 fill-height">
                                                <div class="caption grey--text text--darken-1">Puntos por video</div>
                                                <div class="text-h6 font-weight-bold primary--text">{{ previewPointsPerVideo }}</div>
                                            </v-sheet>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-sheet outlined rounded class="pa-3 fill-height">
                                                <div class="caption grey--text text--darken-1">Valor interno estimado</div>
                                                <div class="text-h6 font-weight-bold primary--text">{{ previewCustomerValue }} USDT ref.</div>
                                            </v-sheet>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-sheet outlined rounded class="pa-3 fill-height">
                                                <div class="caption grey--text text--darken-1">Meta minima interna</div>
                                                <div class="text-h6 font-weight-bold primary--text">{{ previewMinimumValue }}</div>
                                            </v-sheet>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.max_daily_rewards"
                                        label="Videos maximos por dia"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-calendar-clock"
                                        :rules="[rules.req('max_daily_rewards')]"
                                        :error-messages="errors.max_daily_rewards"
                                        :disabled="loading"
                                        @input="clearErrors('max_daily_rewards')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.max_hourly_rewards"
                                        label="Videos maximos por hora"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-clock-fast"
                                        :rules="[rules.req('max_hourly_rewards')]"
                                        :error-messages="errors.max_hourly_rewards"
                                        :disabled="loading"
                                        @input="clearErrors('max_hourly_rewards')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.cooldown_minutes"
                                        label="Minutos entre recompensas"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-timer-sand"
                                        :rules="[rules.req('cooldown_minutes')]"
                                        :error-messages="errors.cooldown_minutes"
                                        :disabled="loading"
                                        @input="clearErrors('cooldown_minutes')"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-divider/>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="form.subscription_enabled"
                                        label="Activar Recompensas Plus"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.subscription_plan_name"
                                        label="Nombre del plan"
                                        prepend-icon="mdi-crown"
                                        :rules="[rules.req('subscription_plan_name')]"
                                        :error-messages="errors.subscription_plan_name"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_plan_name')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.subscription_plan_code"
                                        label="Codigo del plan"
                                        prepend-icon="mdi-identifier"
                                        :rules="[rules.req('subscription_plan_code')]"
                                        :error-messages="errors.subscription_plan_code"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_plan_code')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.subscription_price_usdt"
                                        label="Precio del plan"
                                        type="number"
                                        min="0"
                                        step="0.0001"
                                        suffix="USDT"
                                        prepend-icon="mdi-currency-usd"
                                        :rules="[rules.req('subscription_price_usdt')]"
                                        :error-messages="errors.subscription_price_usdt"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_price_usdt')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.subscription_duration_days"
                                        label="Duracion del plan"
                                        type="number"
                                        min="1"
                                        step="1"
                                        suffix="dias"
                                        prepend-icon="mdi-calendar-range"
                                        :rules="[rules.req('subscription_duration_days')]"
                                        :error-messages="errors.subscription_duration_days"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_duration_days')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="form.subscription_daily_rewards"
                                        label="Videos Plus por dia"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-calendar-star"
                                        :rules="[rules.req('subscription_daily_rewards')]"
                                        :error-messages="errors.subscription_daily_rewards"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_daily_rewards')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="form.subscription_hourly_rewards"
                                        label="Videos Plus por hora"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-clock-plus"
                                        :rules="[rules.req('subscription_hourly_rewards')]"
                                        :error-messages="errors.subscription_hourly_rewards"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_hourly_rewards')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="form.subscription_cooldown_minutes"
                                        label="Minutos Plus entre videos"
                                        type="number"
                                        min="0"
                                        step="1"
                                        prepend-icon="mdi-timer-sand"
                                        :rules="[rules.req('subscription_cooldown_minutes')]"
                                        :error-messages="errors.subscription_cooldown_minutes"
                                        :disabled="loading"
                                        @input="clearErrors('subscription_cooldown_minutes')"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-divider/>
                                </v-col>
                                <v-col cols="12">
                                    <div class="subtitle-1 font-weight-bold mb-2">Canjes por pais</div>
                                    <v-row
                                        v-for="(rule, index) in form.country_redemption_rules"
                                        :key="'country-rule-' + index"
                                        align="center">
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="rule.country"
                                                label="Pais ISO3"
                                                maxlength="3"
                                                prepend-icon="mdi-earth"
                                                :disabled="loading"
                                                @input="rule.country = String(rule.country || '').toUpperCase()"/>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-switch
                                                v-model="rule.usdt_enabled"
                                                label="USDT no AdMob"
                                                color="warning"
                                                disabled/>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-switch
                                                v-model="rule.products_enabled"
                                                label="Productos"
                                                color="primary"
                                                :disabled="loading"/>
                                        </v-col>
                                        <v-col cols="12" md="2" class="text-md-right">
                                            <v-btn icon color="error" :disabled="loading" @click="removeCountryRule(index)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-btn small color="primary" depressed :disabled="loading" @click="addCountryRule">
                                        <v-icon left>mdi-plus-circle</v-icon>Agregar pais
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit" color="success" :loading="loading" :disabled="loading || !valid">
                                <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "configRewards",
    mixins: [ Form ],
    props: ['user'],
    data: () => ({
        loading: true,
        valid: true,
        settings: {},
        rewardModes: [
            { text: 'Puntos desde ingreso estimado', value: 'estimated_revenue' },
            { text: 'Puntos fijos internos', value: 'fixed_points' },
            { text: 'Puntos enviados por AdMob', value: 'admob_reward_amount' }
        ],
        form: {
            enabled: false,
            use_admob_reward_amount: true,
            require_verified_user: true,
            ssv_verification_enabled: true,
            points_per_video: 10,
            point_value_usdt: 0.0001,
            estimated_revenue_per_video_usdt: 0.002,
            customer_share_percent: 50,
            cash_redemption_enabled: false,
            reward_value_mode: 'estimated_revenue',
            min_redeem_points: 1000,
            max_daily_rewards: 20,
            max_hourly_rewards: 5,
            cooldown_minutes: 1,
            subscription_enabled: true,
            subscription_plan_code: 'reward_plus',
            subscription_plan_name: 'Recompensas Plus',
            subscription_price_usdt: 3,
            subscription_duration_days: 30,
            subscription_daily_rewards: 60,
            subscription_hourly_rewards: 12,
            subscription_cooldown_minutes: 1,
            admob_android_ad_unit_id: '',
            admob_ios_ad_unit_id: '',
            admob_reward_item: 'points',
            country_redemption_rules: []
        }
    }),
    created() {
        this.getData();
    },
    computed: {
        previewCustomerValue() {
            return this.formatInternalValue(this.customerValuePerVideo());
        },
        previewPointsPerVideo() {
            return this.formatPoints(this.pointsPerVideo());
        },
        previewMinimumValue() {
            const points = Number(this.form.min_redeem_points || 0);
            const pointValue = Number(this.form.point_value_usdt || 0);

            return this.formatInternalValue(points * pointValue) + ' USDT ref.';
        }
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/settings/rewards').then(res => {
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar recompensas.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        applySettings(settings) {
            this.settings = settings;
            Object.keys(this.form).forEach(key => {
                if (settings[key] !== undefined) {
                    this.form[key] = settings[key];
                }
            });
            this.form.country_redemption_rules = Array.isArray(settings.country_redemption_rules)
                ? settings.country_redemption_rules
                : [];
        },
        addCountryRule() {
            this.form.country_redemption_rules.push({
                country: '',
                usdt_enabled: true,
                products_enabled: false
            });
        },
        removeCountryRule(index) {
            this.form.country_redemption_rules.splice(index, 1);
        },
        customerValuePerVideo() {
            const mode = this.form.reward_value_mode;
            const pointValue = Number(this.form.point_value_usdt || 0);

            if (mode === 'estimated_revenue') {
                return Number(this.form.estimated_revenue_per_video_usdt || 0) * (Number(this.form.customer_share_percent || 0) / 100);
            }

            return this.pointsPerVideo() * pointValue;
        },
        pointsPerVideo() {
            const mode = this.form.reward_value_mode;
            const pointValue = Number(this.form.point_value_usdt || 0);

            if (mode === 'estimated_revenue') {
                return pointValue > 0 ? this.customerValuePerVideo() / pointValue : 0;
            }

            return Number(this.form.points_per_video || 0);
        },
        formatPoints(value) {
            const number = Number(value || 0);

            return number.toLocaleString('es-CO', {
                minimumFractionDigits: number % 1 === 0 ? 0 : 2,
                maximumFractionDigits: 4
            });
        },
        formatInternalValue(value) {
            return Number(value || 0).toLocaleString('en-US', {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6
            });
        },
        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;
            axios.post('/api/settings/rewards', this.form).then(res => {
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.handleErrors(err.response && err.response.data ? err.response.data.errors : {});
                this.$toast.error(this.errorMessage(err, 'No fue posible guardar recompensas.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        copy(value) {
            if (!value) return;

            if (!navigator.clipboard || !navigator.clipboard.writeText) {
                this.$toast.info(value, {icon: 'mdi-link-lock'});
                return;
            }

            navigator.clipboard.writeText(value).then(() => {
                this.$toast.success('Se copio en el portapapeles.', {icon: 'mdi-content-copy'});
            }).catch(() => {
                this.$toast.info(value, {icon: 'mdi-link-lock'});
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
